import { ShieldAlert } from "lucide-react";
import { disclaimers } from "@/data/site";

export const HealthDisclaimer = ({
  text = disclaimers.health,
  title = "Health & medical disclaimer",
  compact = false,
  testId = "health-disclaimer-banner",
}) => (
  <aside
    data-testid={testId}
    role="note"
    className={`glass relative overflow-hidden rounded-2xl ${compact ? "p-4 sm:p-5" : "p-6 sm:p-8"}`}
    style={{ borderColor: "rgba(224,122,95,0.28)" }}
  >
    <span
      aria-hidden
      className="absolute left-0 top-0 h-full w-[3px]"
      style={{ background: "linear-gradient(180deg, var(--accent), transparent)" }}
    />
    <div className="flex gap-4">
      <ShieldAlert
        className="mt-0.5 h-5 w-5 shrink-0"
        style={{ color: "var(--accent)" }}
        aria-hidden
      />
      <div>
        <h3 className="label mb-2">{title}</h3>
        <p className="max-w-3xl text-sm leading-relaxed text-gray-300 sm:text-base">{text}</p>
      </div>
    </div>
  </aside>
);
